import styled from "styled-components";

export const ErrorText = styled.span`
    color: red;
    padding: 0 10px;
`;